import { z } from 'zod';
import { Category } from './category.js';
export const CategoryResponse = z.object({ category: Category });
export const CategoryListResponse = z.object({
    categories: z.array(Category),
});
/** Root → leaf chain returned by `GET /categories/by-id/:id/breadcrumb`.
 *  Unknown IDs return 404. Archived category IDs are visible only to
 *  manager+ callers; guests receive 404 rather than an empty chain. */
export const CategoryBreadcrumbResponse = z.object({
    breadcrumb: z.array(Category),
});
//# sourceMappingURL=responses.js.map